// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n3-3";
export var downloadButton = "_n3-4";
export var fileContainer = "_n3-9 _n3-7";
export var fileContainerBase = "_n3-7";
export var fileContainerFixedHeight = "_n3-8 _n3-7";
export var fileInfo = "_n3-5";
export var fileInfoWidthRestricted = "_n3-6";
export var fileType = "_n3-1";
export var fileTypeName = "_n3-2";
export var image = "_n3-0";
export var link = "_n3-b";
export var overflowEllipsis = "_n3-a";